import { Component } from 'react';
import { Link } from 'react-router-dom';

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary caught:', error, info);
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      const isChunkError =
        this.state.error?.name === 'ChunkLoadError' ||
        this.state.error?.message?.includes('Loading chunk') ||
        this.state.error?.message?.includes('dynamically imported module');

      return (
        <div className="min-h-screen bg-[#F7F7EB] flex items-center justify-center px-6" data-testid="error-boundary">
          <div className="max-w-md text-center">
            <div className="w-16 h-16 mx-auto mb-6 rounded-full bg-[#E5D8D0]/30 flex items-center justify-center">
              <svg className="w-8 h-8 text-[#DEA193]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
              </svg>
            </div>
            <h2 className="font-serif text-2xl text-[#000] mb-3">
              {isChunkError ? 'Connection Lost' : 'Something went wrong'}
            </h2>
            <p className="text-[#737373] mb-8 leading-relaxed">
              {isChunkError
                ? 'The page couldn\'t load — please check your connection and try again.'
                : 'We hit an unexpected issue. Try refreshing or head back to the homepage.'}
            </p>
            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <button
                onClick={() => window.location.reload()}
                className="px-6 py-3 bg-[#000] text-white text-sm uppercase tracking-[0.15em] hover:bg-[#333] transition-colors"
                data-testid="error-reload-btn"
              >
                Refresh Page
              </button>
              <Link
                to="/"
                onClick={this.handleRetry}
                className="px-6 py-3 border border-[#E5D8D0] text-sm uppercase tracking-[0.15em] text-[#000] hover:border-[#000] transition-colors"
                data-testid="error-home-btn"
              >
                Back to Home
              </Link>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
